export const beforeItems = [
  'You spend too much time figuring out where to start.',
  'You jump between technical manuals, videos, forums, and saved notes.',
  "You're not always sure which information you need before proceeding.",
  'You may struggle to distinguish a TCM-related problem from a vehicle, wiring, communication, or transmission issue.',
  'You worry about choosing the wrong tool or proceeding without enough information.',
  'Every unfamiliar TCM feels like starting from zero.',
  'You rely too heavily on memory instead of a repeatable process.',
]

export const afterItems = [
  'You follow a structured process for identifying the TCM.',
  'You know what information to collect before deciding what to do next.',
  'You organize symptoms, fault codes, and diagnostic observations.',
  'You use decision maps to structure your investigation.',
  'You document the checks performed and the results obtained.',
  'You know when additional information or manufacturer-specific procedures are needed.',
  'You follow a more consistent workflow from initial assessment to verification.',
]
